import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import styles from "./WorkPatternImportLeaveConfirmModal.module.css";

interface WorkPatternImportCancelConfirmModalProps {
  isOpen: boolean;
  onKeepImporting: () => void;
  onCancelAnyway: () => void;
}

/**
 * Confirms abandoning an in-progress work pattern import via Cancel import (#400).
 */
export function WorkPatternImportCancelConfirmModal({
  isOpen,
  onKeepImporting,
  onCancelAnyway,
}: WorkPatternImportCancelConfirmModalProps) {
  return (
    <Modal isOpen={isOpen}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2>Cancel import?</h2>
        </div>

        <p className={styles.message}>
          You have an import in progress. If you cancel now, your progress will
          be lost.
        </p>

        <div className={styles.actions}>
          <ButtonGroup>
            <Button variant="primary" onPress={onKeepImporting}>
              Keep importing
            </Button>
            <Button variant="tertiary" onPress={onCancelAnyway}>
              Cancel anyway
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
